module.exports = __webpack_public_path__ + "assets/valance-whale-tail-selected.ab814121.svg";